import React from "react";

import { Banner } from "@/components/Banner";
import { Typography } from "@/components/Typography";
import { FixItModuleProps, FixItStep } from "./types";

import "./styles.scss";

const StepItem = ({ step, content }: FixItStep) => {
  return (
    <div className="fix-it-step">
      <div className="fix-it-step__number">
        <span className="fix-it-step__number-text">{step}</span>
      </div>
      <div className="fix-it-step__content">
        <Typography
          Tag="div"
          classname="fix-it-step__description"
        >
          {content}
        </Typography>
      </div>
    </div>
  );
};

export const FixItModule = ({ data, wrapperSize }: FixItModuleProps) => {
  const { title, richtext, steps, backgroundColor } = data;

  return (
    <Banner
      big
      light
      customBgColor={backgroundColor}
      customClass="fix-it-module__banner"
      {...(wrapperSize && { wrapperSize })}
    >
      <div className="fix-it-module">
        <div className="fix-it-module__header">
          <Typography
            Tag="div"
            classname="fix-it-module__section-title"
          >
            {title}
          </Typography>
        </div>

        <div className="fix-it-module__content">
          {richtext?.map((item, index) => (
            <Typography
              key={index}
              Tag={item.tag}
              size={item.size}
              classname={item.classname}
            >
              {item.content}
            </Typography>
          ))}
        </div>

        <div className="fix-it-module__steps">
          {steps?.map((step, index) => (
            <StepItem
              key={index}
              step={step.step}
              content={step.content}
            />
          ))}
        </div>
      </div>
    </Banner>
  );
};
